export default "__VITE_ASSET__DjAjkJ32__"